import { NumberValue } from '@coveo/bueno';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { isErrorResponse, } from '../../../api/commerce/commerce-api-client.js';
import { requiredEmptyAllowedString, requiredNonEmptyString, validatePayload, } from '../../../utils/validate-payload.js';
import { buildQuerySuggestRequest } from './query-suggest-request-builder.js';
export const clearQuerySuggest = createAction('commerce/querySuggest/clear', (payload) => validatePayload(payload, { id: requiredNonEmptyString }));
export const fetchQuerySuggestions = createAsyncThunk('commerce/querySuggest/fetch', async (payload, { getState, rejectWithValue, extra: { apiClient, validatePayload, navigatorContext }, }) => {
    validatePayload(payload, {
        id: requiredNonEmptyString,
    });
    const state = getState();
    const request = buildQuerySuggestRequest(payload.id, state, navigatorContext);
    const response = await apiClient.querySuggest(request);
    if (isErrorResponse(response)) {
        return rejectWithValue(response.error);
    }
    return {
        id: payload.id,
        query: request.query,
        ...response.success,
    };
});
export const registerQuerySuggest = createAction('commerce/querySuggest/register', (payload) => validatePayload(payload, {
    id: requiredNonEmptyString,
    count: new NumberValue({ min: 0 }),
}));
export const selectQuerySuggestion = createAction('commerce/querySuggest/selectSuggestion', (payload) => validatePayload(payload, {
    id: requiredNonEmptyString,
    expression: requiredEmptyAllowedString,
}));
